import { z } from 'zod'

export const healthResponseSchema = z.object({
  app: z.string(),
  env: z.string(),
  version: z.string(),
})

export type Health = z.infer<typeof healthResponseSchema>
